import { FC, useEffect, useRef, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Header } from "../../components/Header";

import { ProductType } from "../../contexts/ProductsContext";
import styles from "./catalog.module.css";
import { useOrder } from "../../hooks/useOrder";
import { useAppConfig } from "../../hooks/useAppConfig";
import { Menu } from "../../components/Menu";
import { useQuery } from "../../hooks/useQuery";
import { usePluginspace } from "../../hooks/usePluginspace";
import { SellerInfo } from "../../contexts/OrderContext";
import api from "../../services/api";
import { SellerBanner } from "../../components/SellerBanner/sellerBanner";
import { useScroll } from "../../hooks/useScroll";
import { PDVItem } from "../../components/PDVItem";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { HeaderCategories } from "../../components/HeaderCategories";
import { Loading } from "../../components/Loading";
import Swal from "sweetalert2";
import EmptyState from "../../components/EmptyStates/EmptyState";
import { FiltroPdvModal } from "../../components/FiltroProdutos/FiltroProdutos";
import { OrdenacaoProdutos } from "../../components/OrdernacaoProdutos/OrdenacaoProdutos";
import IconesNovos from "../../components/NewIcones/IconesNovos";
import { useProduct } from "../../hooks/useProduct";

type SellerDiscountInfo = {
  discountValue: number;
  sellerInfo: SellerInfo;
};

const Catalog: FC = () => {
  const { getAppConfig,blockLayoutInProduct,saveBlockLayoutInProduct } = useAppConfig();
  const { getToken, registerAccess, getThisPluginspace, getLocations} =
    usePluginspace();
  const { setOpenModalFiltroPDV, getProdutosFilteredByCatalog } = useProduct();
  const { pluginspace_id, id_catalog } = useParams();
  const { getSellerInfo, getCatalogSeller, sellerInfo } = useOrder();
  const orderContext = useOrder();
  const query = useQuery();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const { scrollYProduct, setScrollYProduct } = useScroll();
  const [hasNextPage, setHasNextPage] = useState(true);
  const [products, setProducts] = useState<Array<ProductType>>([]);
  const [sellerInfoDiscount, setSellerInfoDiscount] =
    useState<SellerDiscountInfo>({
      discountValue: 0,
      sellerInfo: {
        cpf: "",
        email: "",
        id: 0,
        name: "",
        numberPhone: "",
        pluginspaceId: 0,
        image: "",
      },
    });



  const [request, setRequest] = useState(false);
  const [page, setPage] = useState(1);
  const [isDown, setIsDown] = useState(false);
 
  const [catalogName, setCatalogName] = useState("");
  const navigate = useNavigate();
  const [sellerDiscount, setSellerDiscount] = useState("0");


  /**Usado para Filtrar e para Ordernar */
  const [orderBy, setOrderBy] = useState("name-asc");
  const [openModalFiltro, setOpenModalFiltro] = useState(false);
  const [imagemVertical, setImagemVertical] = useState(false);

  const loadFirstTimeRef = useRef(true)

  const [metaPage, setMetaPage] = useState<{
    hasNextPage: boolean
    hasPreviousPage: boolean
    itemCount: number
    page: string
    pageCount: number
    take: string
  } | null>();

  async function getConfig() {
    setLoadingHeader(true);
    await getSellerInfo();
    const config: ConfigType | void = await getAppConfig();
    setConfig(config);
    if (config) {
      setImagemVertical(config.content.typeImage !== "square");
    }
    setLoadingHeader(false);
  }

  function calculateDiscount(price: number, discountValueSeller?: string) {
    const discount = parseFloat(
      discountValueSeller ? discountValueSeller : sellerDiscount
    );
    const priceCents = parseFloat((price * 100).toFixed(2));

    const discountValue = priceCents * (discount / 100);
    const finalPrice = (priceCents - discountValue) / 100;
    return parseFloat(finalPrice.toFixed(2));
  }

  async function getVendorInfoByCPF(cpf: string): Promise<{
    discountValue: number;
    sellerInfo: SellerInfo;
  }> {
    return await api
      .post(
        `/api/users/filter`,
        {
          cpf: cpf,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (res: any) => {
        if (res.data) {
          const sellerData = res.data.data[0];

          if (sellerData) {
            const seller: SellerInfo = {
              cpf: sellerData.cpf,
              image: sellerData.image,
              email: sellerData.email,
              id: sellerData.id,
              name: sellerData.name,
              numberPhone: sellerData.numberPhone,
              pluginspaceId: parseInt(sellerData.pluginspaceId),
            };

            orderContext.setSellerInfoData(seller);
            if (sellerData.content) {
              const content = JSON.parse(sellerData.content);
              if (content.discount_value) {
                setSellerDiscount(content.discount_value);

                return {
                  discountValue: parseInt(content.discount_value),
                  sellerInfo: seller,
                };
              }
            }

            return {
              discountValue: 0,
              sellerInfo: seller,
            };
          }
        }

        return {
          discountValue: 0,
          sellerInfo: {
            cpf: "",
            email: "",
            id: 0,
            name: "",
            numberPhone: "",
            pluginspaceId: 0,
            image: "",
          },
        };
      })
      .catch((err) => {
        console.log(err);
        return {
          discountValue: 0,
          sellerInfo: {
            cpf: "",
            email: "",
            id: 0,
            name: "",
            numberPhone: "",
            pluginspaceId: 0,
            image: "",
          },
        };
      });
  }

  async function createVendorCart() {
    if (
      query.get("vendor") !== undefined &&
      query.get("vendor") !== "" &&
      query.get("vendor") != null
    ) {
      // gerar um carrinho informando qual o vendedor

      const x = query.get("vendor");

      const vendedorCPF = atob(x!);
      orderContext.setCatalogSellerFunction(id_catalog ? id_catalog : "");
      orderContext.cpfVendorByLink(vendedorCPF);
      orderContext.setSellerCpfCnpj(vendedorCPF);
      orderContext.setShouldUpdadeCustomerCart(true);
      //registerAccess('category', vendedorCPF, undefined, window.location.pathname)
      // preciso trazer as informações do vendedor para poder jogar o numero dele na função de whatsApp.
      const discountValue = await getVendorInfoByCPF(vendedorCPF);

      return discountValue;
    } else {
      registerAccess("catalog");

      const discountValue = await loadSellerCart();

      return discountValue;
    }
  }

  async function loadSellerCart() {
    try {
      const hasSeller = await orderContext.getCpfVendorByLink();

      if (hasSeller) {
        const discountValue = await getVendorInfoByCPF(hasSeller);
        setSellerInfoDiscount(discountValue);
        return discountValue;
      }

      return {
        discountValue: 0,
        sellerInfo: {
          cpf: "",
          email: "",
          id: 0,
          name: "",
          numberPhone: "",
          pluginspaceId: 0,
          image: "",
        },
      };
    } catch (error) {
      return {
        discountValue: 0,
        sellerInfo: {
          cpf: "",
          email: "",
          id: 0,
          name: "",
          numberPhone: "",
          pluginspaceId: 0,
          image: "",
        },
      };
    }
  }

  async function loadFirstTime() {
    try {
      setLoading(true);
      const discountValue = await createVendorCart();
      await getProductsCatalog([], 1, discountValue, true);
      loadFirstTimeRef.current = false;
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }


  useEffect(() => {
    //registerAccess("catalog");
    getConfig();

    loadFirstTime();
  }, []);

  const scrollToBefore = () => {
    if (scrollYProduct.id) {
      const divItem = document.getElementById(scrollYProduct.id);
      if (divItem) divItem.scrollTop = scrollYProduct.position;
    }
  };

  async function getProductsCatalog(
    newProducts: ProductType[] = [],
    page = 1,
    discountValue: {
      discountValue: number;
      sellerInfo: SellerInfo;
    },
    firstTime: boolean
  ) {
    const configProject: ConfigType | void = await getAppConfig();
    const sellerInfo = discountValue.sellerInfo;
    if (newProducts.length === 0) {
      setLoading(true);
    }


    try {
      await api
        .get(`api/catalog/${window.atob(id_catalog!)}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          const catalogo = response.data.data[0];

          const dateStart = new Date(catalogo.dateStart);
          const dateEnd = new Date(catalogo.dateEnd);
          const today = new Date();

          if (today < dateStart || today > dateEnd) {
            Swal.fire({
              icon: "warning",
              title: "Atenção",
              text: "Este catálogo já expirou ou não está disponível no momento, por favor, tente novamente mais tarde.",
            }).then(() => {
              navigate(`${pluginspace_id}/category`);
            });
          }

          setCatalogName(catalogo.catalog);

          const qtdProductsPagination = configProject?.content.qtdProductsPagination ?? 10
          const showStock = configProject?.content.pdv.showOutStock ?? false;

          const responseProduct = await getProdutosFilteredByCatalog(catalogo.id, page, qtdProductsPagination, showStock, orderBy, firstTime);

          if (responseProduct.data) {
            setHasNextPage(responseProduct.meta ? responseProduct.meta.hasNextPage : false);
            await responseProduct.data.map(async (product: any) => {
              if (
                product.variations[0] &&
                product.variations[0].img &&
                !product.variations[0].img.includes("http")
              ) {
                product.variations[0].img = `https://s3.amazonaws.com/img.ninegrid.com/${product.variations[0].img}`;
              }


              const calculeDiscount = catalogo.catalogItems.find(
                (item: any) => item.productId === product.id
              );
              const catalogIdF = await getCatalogSeller();

              const catalogId = window.atob(catalogIdF);
              if (
                calculeDiscount &&
                calculeDiscount.allowDiscount &&
                sellerInfo &&
                sellerInfo.id === catalogo.sellerId &&
                catalogo.id === parseInt(catalogId)
              ) {
                product.variations[0].promotionalPrice = calculateDiscount(
                  product.variations[0].price,
                  discountValue.discountValue.toString()
                );
                product.hasDiscount = true;
                product.discountValue = discountValue.discountValue.toString();
              }

              newProducts.push(product);
            });
            const productsAdd = newProducts
              .filter(
                (product) =>
                  product.variations.length > 0 &&
                  parseInt(product.classificationId) > 0 &&
                  product.type !== "optional" &&
                  !product.sellAsFractional
              )

            setProducts(productsAdd);
            setRequest(false);
            setLoading(false);
          }

        })
    } catch (error) {
      setProducts([]);
      setRequest(false);
      setLoading(false);
    }

    scrollToBefore();
  }

  const saveScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    setScrollYProduct({
      id: event.currentTarget.id,
      position: event.currentTarget.scrollTop,
    });
  };

  function checkBottom(event: any) {
    saveScroll(event);

    if (event.target.scrollTop > 0) setIsDown(true);
    else setIsDown(false);

    const bottom =
      event.target.scrollHeight -
      event.target.scrollTop -
      event.target.clientHeight <=
      90;
    if (bottom && !request) {
      if (!hasNextPage) return;
      const newPage = page + 1;
      setPage(newPage);
      setRequest(true);

      getProductsCatalog(Object.assign(products), newPage, sellerInfoDiscount, false);
    }
  }
  function goTop() {
    const divItem = document.getElementById("content-pdv");
    if (divItem) {
      divItem.scroll({ behavior: "smooth", top: 0 });
    }
  }

  const [searchParams] = useSearchParams();
  const [lastRefresh, setLastRefresh] = useState(searchParams.get("refresh"));

  useEffect(() => {
    const interval = setInterval(() => {
      const newRefresh = searchParams.get("refresh");
      if (loadFirstTimeRef.current) return;
      if (newRefresh && newRefresh !== lastRefresh) {
        setLastRefresh(newRefresh);
        setLoading(true);
        getProductsCatalog([], 1, sellerInfoDiscount, false);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [searchParams, lastRefresh]);


  useEffect(() => {
    if (loadFirstTimeRef.current) return;
    setLoading(true);
    getProductsCatalog([], 1, sellerInfoDiscount, false);
  }, [orderBy])


  return (
    <div className={styles.page}>
      <div className={styles.pageContent} onScroll={(e: any) => checkBottom(e)}>
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
            extraSpacingLeftMenu
          />
        )}

        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <HeaderCategories
              fontColor={
                config?.webappcolor.fonttitlebar
                  ? config.webappcolor.fonttitlebar
                  : "#FFFFFF"
              }
              backgroundColor={
                config?.webappcolor.backgroundtitlebar
                  ? config.webappcolor.backgroundtitlebar
                  : "#000000"
              }
              categories={[catalogName]}
              linkToNavigate={`/${pluginspace_id}/category`}
              blockViewMode={
                config && config.content.noUseViewMode
                  ? config.content.noUseViewMode
                  : false
              }
              inBlocks={blockLayoutInProduct}
              setInBlocks={saveBlockLayoutInProduct}
            />

            <div
              onClick={() => goTop()}
              className="pdv-arrow-top"
              style={
                isDown
                  ? {
                    visibility: "inherit",
                    border: `1px solid ${config?.webappcolor.backgroundtitlebar
                      ? config.webappcolor.backgroundtitlebar
                      : "#EAEAEA"
                      }`,
                  }
                  : {
                    visibility: "hidden",
                  }
              }
            >
              <i
                style={{
                  color: `${config?.webappcolor.backgroundtitlebar
                    ? config.webappcolor.backgroundtitlebar
                    : "#EAEAEA"
                    }`,
                }}
                className="fa fa-arrow-up"
              ></i>
            </div>

            <div
              style={{
                marginTop: "88px",
                width: "100%",
                overflow: "auto",
                height: "100%",
                gap: "16px",
                display: "flex",
                flexDirection: "column",
                padding: "0 0 16px",
                flexGrow: 1,
              }}
            >
              {/*Novo baner do vendedor caso o cliente recebeu o link dele */}

              <div style={{ width: "100%", padding: "16px 16px 0px", boxSizing: "border-box", display: sellerInfo?.id ? "block" : "none" }}>
                <SellerBanner />
              </div>
              {/*Componentes para Filtro */}
              <div style={{ display: "flex", gap: "0.5rem", padding: "0 1rem", marginTop: !sellerInfo ? "16px" : "0" }}>
                <OrdenacaoProdutos orderBy={orderBy} onSelectOrderBy={setOrderBy} />
                <button className={styles.button_modal_teste_12u3y12ashj} onClick={() => setOpenModalFiltroPDV(true)}>
                  <IconesNovos cor={"#636363"}
                    active={true} type={'filter_small'} action={() => null} />
                  Filtrar </button>
              </div>

              <div className={styles.info_container_12897uif79} >
                {metaPage && <span><b> {metaPage.itemCount} </b> PRODUTOS</span>
                }            <span><b> Você está em:</b> {catalogName} </span>
              </div>


              {products.length == 0 ? (
                <div className={styles.empty_state_jhkalds}>
                  <EmptyState type={"catalog"} textButton={""} colorIcon={config?.webappcolor.iconsheader
                    ? config.webappcolor.iconsheader
                    : "#CEA127"}
                    noShowBackground
                  />
                </div>
              ) : (

                <>
                  <div className={blockLayoutInProduct ? styles["items-pdv"] : styles["items-pdv-list"]}>
                    {
                      products.map((product) => {
                        if (product.variations.length > 0) {
                          let productImg = product.images.find(
                            (image) => image.typeimg === "imgsmall"
                          )?.imgsuffix;
                          if (!productImg) {
                            productImg = "/imagem/produto-sem-imagem.png";

                          }
                          return (
                            <>
                              <PDVItem
                                id={product.id}
                                type={product.type}
                                name={product.name}
                                reference_id={product.variations[0].referenceCode}
                                price={product.variations[0].price}
                                promotionalPrice={product.variations[0].promotionalPrice}
                                image={productImg ? productImg : ""}
                                inBlocks={blockLayoutInProduct}
                                description={product.description}
                                key={product.id}
                                fontColor={"#636363"}
                                food={config?.template === "food" ||
                                  config?.template === "retail"}
                                noImage={config?.content.pdv.noProductImages
                                  ? config?.content.pdv.noProductImages
                                  : false}
                                hasDiscount={product.hasDiscount}
                                discountValue={product.discountValue}
                                discountCoupon={{
                                  color: config?.webappcolor.flagDiscountColor
                                    ? config.webappcolor.flagDiscountColor
                                    : "#000",
                                  type: config?.content.flagDiscount
                                    ? config?.content.flagDiscount
                                    : "trigonal",
                                }}
                                stock={!!product.variations.find(e => e.inventory > 0)?.inventory}
                                mark={product.mark ? product.mark.name : "-/-"}
                                isVertical={imagemVertical}
                              />
                            </>
                          );
                        }
                      })
                    }
                  </div>

                </>
              )

              }
            </div>
          </>

        )}

        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
      <FiltroPdvModal />
    </div>
  );
};

export { Catalog };
